<template>
    <div v-if="group">
        <b-modal
            size="lg"
            v-model="modalShow"
            title="利用アカウントの発行"
            ok-only
            @ok="handleOk"
            @hidden="close">
            <div class="row">
                <div class="col-12">
                    <div class="form-group m-form__group">
                        <label class="is-required-ja">メールアドレス</label>
                        <div
                            class="invitationEmailsWrapper"
                            ref="invitationEmailsWrapper">
                            <div v-for="(email, index) in invitation.emails">
                                <div
                                    :class="{ 'mb-2' : !errors[`emails.${index}`] }"
                                    class="d-flex align-items-center">
                                    <input
                                        v-model="invitation.emails[index].email"
                                        @change="updateEmailList"
                                        :id="`invitation_email_${index}`"
                                        class="form-control m-input"
                                        :class="{ 'is-invalid' : errors[`emails.${index}.email`] }"
                                        type="text"
                                        autocomplete="off"
                                        placeholder="メールアドレスを入力してください">
                                    <input
                                        v-model="invitation.emails[index].last_name"                    
                                        :id="`invitation_last_name_${index}`"
                                        class="form-control m-input ml-1 input-name "
                                        :class="{ 'is-invalid' : errors[`emails.${index}.last_name`] }"
                                        type="text"
                                        autocomplete="off"
                                        placeholder="姓">
                                    <input
                                        v-model="invitation.emails[index].first_name"
                                        :id="`invitation_first_name_${index}`"
                                        class="form-control m-input ml-1 input-name "
                                        :class="{ 'is-invalid' : errors[`emails.${index}.first_name`] }"
                                        type="text"
                                        autocomplete="off"
                                        placeholder="名">
                                    <div
                                        v-if="invitation.emails.length > 1 && invitation.emails.length !== index + 1"
                                        @click="onClickRemoveEmail(index)"
                                        class="incDecButton incDecButton-width incDecButtonRemove">
                                        -
                                    </div>
                                    <div
                                        v-if="invitation.emails.length === index + 1"
                                        @click="onClickAddEmail"
                                        class="incDecButton incDecButton-width">
                                        +
                                    </div>
                                </div>
                                <div
                                    v-if="errors[`emails.${index}.email`] || errors[`emails.${index}.last_name`] || errors[`emails.${index}.first_name`]"
                                    class="mb-2">
                                    <div
                                        v-if="errors[`emails.${index}.email`]"
                                        class="invalid-feedback d-block">
                                        {{ errors[`emails.${index}.email`][0] }}
                                    </div>
                                    <div
                                        v-if="errors[`emails.${index}.last_name`]"
                                        class="invalid-feedback d-block">
                                        {{ errors[`emails.${index}.last_name`][0] }}
                                    </div>
                                    <div
                                        v-if="errors[`emails.${index}.first_name`]"
                                        class="invalid-feedback d-block">
                                        {{ errors[`emails.${index}.first_name`][0] }}
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="errors.email"
                                class="invalid-feedback d-block">
                                {{ errors.email[0] }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="d-flex justify-content-between align-items-center">
                        <div
                            class="small visible pl-1 pr-2"
                            :class="{ 'invisible' : csv.readCount < 1 }">
                            <span class="text-success">{{ `${csv.readCount}件のメールアドレスをインポートしました` }}</span><!--
                         --><span v-if="csv.dupCount > 0" class="text-muted">{{ `（${csv.dupCount}件が重複しています）` }}</span>
                        </div>
                        <b-button
                            size="sm"
                            variant="yokumiru-blue"
                            class="btnImport"
                            @click="triggerImportCSV">
                            メールアドレスをCSVインポート
                        </b-button>
                    </div>
                    <b-form-file
                        v-model="csv.file"
                        ref="fileinput"
                        accept="text/csv"
                        id="formFileImportCSV"
                        style="width:0;height:0;overflow:hidden;visibility:hidden;"
                        @change="importCSV">
                    </b-form-file>
                </div>
                <div class="col-12">
                    <div class="form-group m-form__group">
                        <label for="plan" class="is-required-ja">サービス</label>
                        <select
                            v-model="invitation.plan"
                            id="plan"
                            class="form-control"
                            :class="{ 'is-invalid' : errors.plan_id }">
                            <option :value="null">サービスを選択してください</option>
                            <option
                                v-for="plan in group.plans"
                                :value="plan"
                                :key="`plan_${plan.id}`">
                                {{ plan.name }}
                            </option>
                        </select>
                        <div
                            v-if="errors.plan_id"
                            class="invalid-feedback d-block">
                            {{ errors.plan_id[0] }}
                        </div>
                    </div>
                </div>

                <template v-if="isDoctorPass">
                    <div class="col-12 flatpickrWrapper">
                        <div class="form-group m-form__group">
                            <label class="is-required-ja">
                                <span class="u-palt">出国日</span>
                                <span class="text-muted u-palt">（日本時間）</span>
                            </label>
                            <flat-pickr
                                v-model="invitation.period_start"
                                :config="flatPickrConfig"
                                class="form-control"
                                :class="{ 'is-invalid' : errors.period_start }"
                                placeholder="選択してください"
                                @input="onChangeSubscriptionPeriod(invitation.period_start, invitation.period_end)"/>
                            <div
                                v-if="errors.period_start"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.period_start[0] }}
                            </div>
                        </div>
                    </div>
                    <div class="col-12 flatpickrWrapper">
                        <div class="form-group m-form__group">
                            <label class="is-required-ja">
                                <span class="u-palt">帰国日</span>
                                <span class="text-muted u-palt">（日本時間）</span>
                            </label>
                            <flat-pickr
                                v-model="invitation.period_end"
                                :config="flatPickrConfig"
                                class="form-control"
                                :class="{ 'is-invalid' : errors.period_end }"
                                placeholder="選択してください"
                                @input="onChangeSubscriptionPeriod(invitation.period_start, invitation.period_end)"/>
                            <div
                                v-if="errors.period_end"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.period_end[0] }}
                            </div>
                        </div>
                    </div>
                    <div class="period-length text-muted">
                        渡航日数：{{period_length > 0 ? period_length : '-'}}日
                    </div>
                </template>

                <div class="col-12">
                    <div class="form-group m-form__group">
                        <label for="group_id">所属法人</label>
                        <select
                            v-model="invitation.child_group_id"
                            id="child_group_id"
                            class="form-control"
                            :class="{ 'is-invalid' : errors.child_group_id }">
                            <option :value="null">---</option>
                            <option
                                v-for="company in companies"
                                :value="company.id">
                                {{ company.name }}
                            </option>
                        </select>
                        <div v-if="errors.child_group_id"
                             class="invalid-feedback d-block">
                            {{ errors.child_group_id[0] }}
                        </div>
                    </div>
                </div>
                <div
                    v-if="invitation.child_group_id !== null"
                    class="col-12">
                    <div class="form-group m-form__group">
                        <label for="group_id">法人担当者の設定</label>
                        <select
                            v-model="invitation.authorizer_email"
                            id="authorizer_email"
                            class="form-control"
                            :class="{ 'is-invalid' : errors.authorizer_email }">
                            <option :value="null">設定しない</option>
                            <option
                                v-for="email in selectableEmails"
                                :value="email">
                                {{ email }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="col-12">
                    <div class="form-group">
                        <div class="form-check form-check-inline mb-1">
                            <input
                                v-model="isOverwriteGroupName"
                                type="checkbox"
                                id="isOverwriteGroupName"
                                class="form-check-input"
                                value="1">
                            <label
                                for="isOverwriteGroupName"
                                class="mb-0">
                                メール通知に記載する{{ groupTypeName }}名を上書き
                            </label>
                        </div>
                        <div class="form-group m-form__group">
                            <input
                                v-model="invitation.group_name"
                                type="text"
                                id="group_name"
                                class="form-control m-input"
                                :class="{ 'is-invalid' : errors.group_name }"
                                :placeholder="`${groupTypeName}名を入力してください`"
                                :readonly="isOverwriteGroupName === false">
                            <div
                                v-if="errors.group_name"
                                class="invalid-feedback d-block">
                                {{ errors.group_name[0] }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                slot="modal-footer"
                class="w-100" :class="{ 'u-loader u-loader--sm' : inProgress }">
                <div class="d-flex justify-content-center">
                    <button
                        class="btn btn-yokumiru-orange"
                        :disabled="inProgress"
                        @click="handleOk">
                        発行する
                    </button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import constants from '../../../../constants'
import YokumiruHelper from '../../../../YokumiruHelper'
import moment from 'moment-timezone'
import flatPickr from 'vue-flatpickr-component'
import { Japanese } from 'flatpickr/dist/l10n/ja.js'

export default {
    components: {
        flatPickr,
    },

    data: function () {
        return {
            helper: YokumiruHelper,
            inProgress: false,
            modalShow: false,
            group: null,
            companies: [],
            csv: {
                file: null,
                readCount: 0,
                dupCount: 0,
            },
            isOverwriteGroupName: false,
            invitation: {
                group_id: null,
                child_group_id: null,
                is_authorizer: false,
                authorizer_email: null,
                emails: [null],
                plan: null,
                period_start: null,
                period_end: null,
                group_name: null,
            },
            flatPickrConfig: {
                locale: Japanese,
                disable: [{
                    from: '0000-01-01',
                    to: moment().subtract(1, 'days').format('YYYY-MM-DD'),
                }],
            },
            errors: {},
            period_length: 0,
        }
    },

    computed: {
        groupTypeName: function () {
            if (!this.group) return ''
            return this.helper.groupTypeName(this.group.group_type)
        },

        isDoctorPass: function () {
            return this.helper.isDoctorPass(this.invitation.plan)
        },

        selectableEmails: function () {
            return this.invitation.emails.filter((v) => v.email !== null).map((v) => v.email)
        },
    },

    watch: {
        group: function (group) {
            if (group) {
                this.invitation.group_name = group.name
            }
        },

        'invitation.emails': function () {
            this.invitation.authorizer_email = null
        },

        'invitation.child_group_id': function (val) {
            if (!val) {
                this.invitation.authorizer_email = null
            }
        },
    },

    created: function () {
        bus.$on('open-modal-authorizer-user-invite', this.open)
    },

    beforeDestroy: function () {
        bus.$off('open-modal-authorizer-user-invite')
    },

    methods: {
        /**
         * モーダル表示
         *
         * @param {object} group
         */
        open: function (group) {
            this.initInvitation()
            this.group = {...group}
            this.companies = group.child_groups
            this.errors = {}
            this.modalShow = true
        },

        /**
         * モーダルを閉じる
         */
        close: function () {
            this.modalShow = false
        },

        /**
         * 利用アカウント発行データの初期化
         */
        initInvitation: function () {
            this.isOverwriteGroupName = false

            this.csv = {
                file: null,
                readCount: 0,
                dupCount: 0,
            }

            this.invitation = {
                group_id: null,
                child_group_id: null,
                authorizer_email: null,
                emails: [{ email: null, last_name: null, first_name: null }],
                plan: null,
                period_start: null,
                period_end: null,
                group_name: null,
            }

            this.period_length = 0
        },

        /**
         * メールアドレス入力エリアの最下部にスクロール
         */
        scrollInvitationEmailsWrapper() {
            const wrapper = this.$refs.invitationEmailsWrapper
            setTimeout(() => wrapper.scrollTop = wrapper.scrollHeight, 10)
        },

        /**
         * メールアドレス入力エリアを追加
         */
        onClickAddEmail: function () {
            this.invitation.emails.push({ email: null, last_name: null, first_name: null})
            this.scrollInvitationEmailsWrapper()
        },

        /**
         * 利用プランの選択プルダウンを削除
         * @param {number} index
         */
        onClickRemoveEmail: function (index) {
            this.invitation.emails.splice(index, 1)
        },

        /**
         * 利用プランの選択状態をアップデート
         */
        updateEmailList: function () {
            // すべて取り除かれた場合
            if (this.invitation.emails.length < 1) {
                this.invitation.emails.push({ email: null, last_name: null, first_name: null })
            }
        },

        /**
         * CSVインポートのトリガー
         */
        triggerImportCSV: function () {
            document.getElementById('formFileImportCSV').click()
        },

        /**
         * CSVインポート
         * @see https://github.com/sewii/Yokumiru/issues/680
         */
        importCSV: function(e) {
            const elem = e.target
            this.errors = {}

            const reader = new FileReader
            reader.onload = (e) => {
                const rows = this.$papa.parse(e.target.result, { skipEmptyLines: true }).data
                const emails = rows.map((row) => row[0])
                const email_rows = rows.map((row) => {
                    return {
                        email: row[0],
                        last_name: row[1],
                        first_name: row[2],
                    }
                })
                const uniqEmails = Array.from(new Set(emails))

                this.csv.readCount = emails.length
                this.csv.dupCount = emails.length - uniqEmails.length
                this.invitation.emails = email_rows
            }

            if (elem.files.length > 0) {
                reader.readAsText(elem.files[0])
            }
            // 同じファイルを再度選択した場合でも @change が発火するように対策
            document.getElementById('formFileImportCSV').value = ''
        },

        /**
         * 送信ボタン押下時
         *
         * @param {object} e
         */
        handleOk: function (e) {
            e.preventDefault()
            this.invite()
        },

        /**
         * 利用アカウントの発行
         */
        invite: async function () {
            if (this.inProgress) return
            this.inProgress = true
            this.errors = {}

            const data = { ...this.invitation }
            
            data.emails = this.invitation.emails.filter((v) => v.email !== null)
            data.plan_id = this.invitation.plan ? this.invitation.plan.id : null

            // 利用するサービスがドクターパスでなければ帰国日・出国日の設定をクリア
            if (!this.isDoctorPass) {
                data.period_start = null
                data.period_end = null
            }

            // 利用アカウント発行時に団体名を別名に上書きできるようにする
            // @see https://github.com/sewii/Yokumiru/issues/701
            if (!this.isOverwriteGroupName) {
                data.group_name = null
            }

            const endpoint = constants.user.groups.endpoint.base

            await axios.post(`${endpoint}/${this.group.id}/invitations`, data)
                .then(() => {
                    bus.$emit('alert-success', '利用アカウントを発行しました。')
                    bus.$emit('group-invitations-send')
                    this.close()
                })
                .catch(({response}) => {
                    if (response && response.hasOwnProperty('data') && response.data.hasOwnProperty('errors')) {
                        if (response.data.errors.hasOwnProperty('message')) {
                            bus.$emit('alert-danger', response.data.errors.message[0])
                        }
                        else {
                            this.errors = response.data.errors
                            bus.$emit('alert-danger')
                        }
                    }
                    else {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    }
                })

            this.inProgress = false
        },
        onChangeSubscriptionPeriod(ps, pe) {
            if (!ps && !pe) {
                return
            }
              
            const length = moment(pe).diff(moment(ps), 'days')

            if (length >= 0) {
                this.period_length = length + 1
            }
            else {
                this.period_length = 0
            }
        },
    },
}
</script>

<style scoped lang="scss">
.btnImport {
    min-width: 210px;
}

.invitationEmailsWrapper {
    padding-right:5px;
    max-height: 220px;
    overflow-y: scroll;
}

.flatpickrWrapper {
    input.form-control:disabled,
    input.form-control[readonly] {
        background: transparent;
    }
}

.incDecButton {
    width: 37px;
    height: 37px;
    margin-left: 10px;
    line-height: 37px;
    color: #fff;
    font-weight: bold;
    text-align: center;
    background: #4E7DAB;
    border-radius: 5px;
    cursor: pointer;

    &.incDecButtonRemove {
        color: #818181;
        background: #e8e8e8;
    }
}

.input-name{
    flex-basis: 300px;
}

.incDecButton-width{
    width: 70px;
}

.period-length {
    font-size: 13px;
    text-align: end;
    width: 100%;
    padding: 0 15px 0 15px;
}
</style>
